module.exports = __webpack_public_path__ + "79fdb369270a5c34154f3bceb1435cfc.MP3";